import config from '../../../config'
import i18n from '../../../services/i18n'
import { notify } from '../../../actions/notifications'
import { Actions as SocketActions, fetchConnectedDevices } from '../../../actions/socket'
import { deviceConnectedSocket, deviceConnectedSocketArray, deviceDisconnectedSocket, downloadPercentage, screenshotReceived } from '../../../actions/stores'
import FeedbackQueue from './FeedbackQueue'

const { map: { timeToGoOffline = 5000 } = {} } = config

const timeouts = {}

const queueDispatcher = new FeedbackQueue()
queueDispatcher.start()

/**
 * On socket is connecting
 */
const onConnecting = () => ({
    type: SocketActions.SOCKET_CONNECTING,
})

/**
 * On socket has connected
 */
const onConnection = () => (pDispatch) => {
    pDispatch({
        type: SocketActions.SOCKET_CONNECTED,
    })
    pDispatch(fetchConnectedDevices())
}

/**
 * On socket is disconnecting
 */
const onDisconnecting = () => ({
    type: SocketActions.SOCKET_DISCONNECTING,
})

/**
 * On socket has disconnected
 */
const onDisconnection = () => ({
    type: SocketActions.SOCKET_DISCONNECTED,
})

/**
 * On device has connected
 * @param {String} uid Device id
 */
const onDeviceConnection = (uid) => (pDispatch) => {
    // Check if the device was going to offline
    if (timeouts[uid]) {
        clearTimeout(timeouts[uid])
        // Set the device as connected silently
        pDispatch(deviceConnectedSocket(uid, false))
    } else {
        pDispatch(deviceConnectedSocket(uid, false))
    }
}

/**
 * On device has disconnected
 * @param {String} uid Device id
 */
const onDeviceDisconnection = (uid) => (pDispatch) => {
    // Timeout going offline
    timeouts[uid] = setTimeout(() => pDispatch(deviceDisconnectedSocket(uid, false)), timeToGoOffline)
}

/**
 * On device sends download percentage
 * @param {String} uid device id
 * @param {String} downPercValue percentage
 */
const onDownloadPercentage = (uid, downPercValue) => (pDispatch) => {
    pDispatch(downloadPercentage(uid, downPercValue))
}

/**
 * On device sends screenshot
 * @param {String} uid device id
 * @param {String} screenshot
 */
const onScreenshot = (uid, screenshot) => (pDispatch) => {
    pDispatch(screenshotReceived(uid, screenshot))
}

/**
 * On device sends open status panel
 * @param {String} uid device id
 */
const onOpenStatusPanel = (uid) => (pDispatch) => {
    console.log('ON OPEN STATUS PANEL', uid)
}

const onClearDeviceCache = (uid) => (pDispatch) => {
    console.log('On clear device cache', uid);
}

const onClearDeviceContent = (uid) => (pDispatch) => {
    console.log('On clear device content', uid);
}

/**
 * On connected device list is received
 * @param {Array} devices Connected devices
 */
const onFetchConnectedDevices = (devices) => (pDispatch) => {
    pDispatch(deviceConnectedSocketArray(devices, false))
}

function builQueueCallback(dispatch) {
    return (group, queue) => {
        const { message: queueMessage } = queue[0] || {}

        let messageKey

        switch (queueMessage) {
            case 'content-update':
                messageKey = 'message-content-update'
                break
            case 'reboot':
                messageKey = 'message-reboot'
                break
            case 'screenshot':
                messageKey = 'message-screenshot'
                break
            case 'settings-update':
                messageKey = 'message-settings-update'
                break
            default:
                return null
        }

        dispatch(
            notify({
                title: i18n.t(messageKey, { context: 'title', count: queue.length }),
                body: i18n.t(messageKey, { context: 'body', count: queue.length }),
            })
        )
    }
}

/**
 * Processes messages sent by any device
 * @param {String} device Device ID
 * @param {*} message Message sent by the socket server
 * @param {String} group Message group ID
 */
function onDeviceFeedback(device, message, group) {
    return (dispatch) => {
        const callback = builQueueCallback(dispatch)
        queueDispatcher.push(group, callback, {
            device,
            message,
            group,
        })
    }
}

export {
    onConnecting,
    onConnection,
    onDeviceConnection,
    onDeviceDisconnection,
    onDeviceFeedback,
    onDisconnecting,
    onDisconnection,
    onDownloadPercentage,
    onFetchConnectedDevices,
    onScreenshot,
    onOpenStatusPanel,
    onClearDeviceContent,
    onClearDeviceCache,
}
